<template>
    <div class="shrink-0 w-[--sidebar-width] pl-6 -ml-4 flex items-center">
        <span class="paragraph-md-bold text-primary">
            <slot />
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
